import { FC } from 'react'
import classNames from 'classnames'

export type IconName =
  | 'account'
  | 'business-settings'
  | 'code'
  | 'search'
  | 'circle-help'
  | 'dashboard'
  | 'whatsapp'
  | 'verify'
  | 'add-business'
  | 'add-user'
  | 'add-card'
  | 'edit'
  | 'poa'
  | 'photo-id'
  | 'introduction'
  | 'sendRequest'
  | 'invoices'
  | 'infoCircle'
  | 'error'
  | 'download'
  | 'forward'
  | 'logout'
  | 'mail'
  | 'market'
  | 'link'
  | 'team'
  | 'warning'
  | 'settings'
  | 'info'
  | 'hamburger-menu'
  | 'close'
  | 'mailDefault'
  | 'delete'
  | 'check-circle'
  | 'check-outline'
  | 'calendar'
  | 'filter'
  | 'admin'
  | 'copy'
  | 'download-outline'
  | 'scan'
  | 'circle'
  | 'user-settings'
  | 'trash'
  | 'phone'
  | 'user'
  | 'chevron-right'
  | 'chevron-left'
  | 'storage'
  | 'user-circle-filled'
  | 'hamburger-straight'

export type IconType = React.DetailedHTMLProps<
  React.HTMLAttributes<SVGSVGElement>,
  SVGSVGElement
> & {
  name: IconName
  width?: number
  height?: number
  fill?: 'white' | 'danger' | 'success' | 'body' | 'dark300' | 'dark' | 'action'
  stroke?:
    | 'white'
    | 'danger'
    | 'success'
    | 'body'
    | 'dark300'
    | 'dark'
    | 'action'
}

const Icon: FC<IconType> = ({
  fill = 'dark300',
  height,
  name,
  stroke,
  width,
  ...rest
}) => {
  const className = classNames(
    !!stroke && `stroke-${stroke}`,
    !!fill && `text-${fill}`,
    rest.className,
  )
  switch (name) {
    case 'link': {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
        >
          <path
            d='M18.3638 15.536L16.9498 14.12L18.3638 12.706C18.8314 12.2424 19.2029 11.6911 19.4568 11.0836C19.7108 10.4761 19.8423 9.8244 19.8437 9.16595C19.8452 8.5075 19.7166 7.85525 19.4652 7.24665C19.2139 6.63804 18.8449 6.08507 18.3793 5.61947C17.9137 5.15387 17.3607 4.78483 16.7521 4.53351C16.1435 4.2822 15.4913 4.15357 14.8328 4.15502C14.1744 4.15646 13.5227 4.28794 12.9152 4.54192C12.3077 4.79589 11.7563 5.16736 11.2928 5.63499L9.87877 7.04999L8.46377 5.63599L9.87977 4.22199C11.1926 2.90917 12.9732 2.17163 14.8298 2.17163C16.6864 2.17163 18.4669 2.90917 19.7798 4.22199C21.0926 5.53481 21.8301 7.31538 21.8301 9.17199C21.8301 11.0286 21.0926 12.8092 19.7798 14.122L18.3648 15.536H18.3638ZM15.5358 18.364L14.1208 19.778C12.8079 21.0908 11.0274 21.8283 9.17077 21.8283C7.31416 21.8283 5.53359 21.0908 4.22077 19.778C2.90795 18.4652 2.17041 16.6846 2.17041 14.828C2.17041 12.9714 2.90795 11.1908 4.22077 9.87799L5.63577 8.46399L7.04977 9.87999L5.63577 11.294C5.16814 11.7575 4.79667 12.3089 4.5427 12.9164C4.28872 13.5239 4.15724 14.1756 4.1558 14.834C4.15435 15.4925 4.28298 16.1447 4.53429 16.7533C4.78561 17.3619 5.15465 17.9149 5.62025 18.3805C6.08585 18.8461 6.63882 19.2152 7.24743 19.4665C7.85603 19.7178 8.50828 19.8464 9.16673 19.845C9.82518 19.8435 10.4769 19.712 11.0844 19.4581C11.6919 19.2041 12.2432 18.8326 12.7068 18.365L14.1208 16.951L15.5358 18.365V18.364ZM14.8278 7.75699L16.2428 9.17199L9.17177 16.242L7.75677 14.828L14.8278 7.75799V7.75699Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    }
    case 'add-business': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M11.5625 6V2H1.5625V20H15.5625V18H11.5625V16H13.5625V14H11.5625V12H13.5625V10H11.5625V8H19.5625V14H21.5625V6H11.5625ZM5.5625 18H3.5625V16H5.5625V18ZM5.5625 14H3.5625V12H5.5625V14ZM5.5625 10H3.5625V8H5.5625V10ZM5.5625 6H3.5625V4H5.5625V6ZM9.5625 18H7.5625V16H9.5625V18ZM9.5625 14H7.5625V12H9.5625V14ZM9.5625 10H7.5625V8H9.5625V10ZM9.5625 6H7.5625V4H9.5625V6ZM23.5625 18V20H21.5625V22H19.5625V20H17.5625V18H19.5625V16H21.5625V18H23.5625ZM17.5625 10H15.5625V12H17.5625V10ZM17.5625 14H15.5625V16H17.5625V14Z'
            fill='white'
          />
        </svg>
      )
    }
    case 'search': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 22 22'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M14.7641 13.2641H13.9741L13.6941 12.9941C14.7907 11.7165 15.3496 10.0637 15.2535 8.38275C15.1575 6.70182 14.4139 5.12347 13.1789 3.97908C11.944 2.8347 10.3137 2.21329 8.63029 2.24532C6.94691 2.27735 5.34142 2.96034 4.15088 4.15088C2.96034 5.34142 2.27735 6.94691 2.24532 8.63029C2.21329 10.3137 2.8347 11.944 3.97908 13.1789C5.12347 14.4139 6.70182 15.1575 8.38275 15.2535C10.0637 15.3496 11.7165 14.7907 12.9941 13.6941L13.2641 13.9741V14.7641L18.2641 19.7541L19.7541 18.2641L14.7641 13.2641ZM8.76408 13.2641C7.87407 13.2641 7.00404 13.0002 6.26402 12.5057C5.52399 12.0112 4.94722 11.3084 4.60662 10.4862C4.26603 9.66389 4.17692 8.75909 4.35055 7.88618C4.52418 7.01326 4.95277 6.21144 5.5821 5.5821C6.21144 4.95277 7.01326 4.52418 7.88618 4.35055C8.75909 4.17692 9.66389 4.26603 10.4862 4.60662C11.3084 4.94722 12.0112 5.52399 12.5057 6.26402C13.0002 7.00404 13.2641 7.87407 13.2641 8.76408C13.2649 9.35525 13.149 9.94077 12.9231 10.4871C12.6973 11.0334 12.3658 11.5298 11.9478 11.9478C11.5298 12.3658 11.0334 12.6973 10.4871 12.9231C9.94077 13.149 9.35525 13.2649 8.76408 13.2641Z'
            fill='#6E6E73'
          />
        </svg>
      )
    }
    case 'filter': {
      return (
        <svg
          width={width || '16'}
          height={height || '14'}
          viewBox='0 0 16 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0.470703 2.04297C0.470703 1.69141 0.587891 1.39844 0.822266 1.16406C1.05664 0.929688 1.34961 0.8125 1.70117 0.8125H14.2402C14.5918 0.8125 14.8848 0.929688 15.1191 1.16406C15.3535 1.39844 15.4707 1.69141 15.4707 2.04297C15.4707 2.33594 15.3828 2.58984 15.207 2.80469L10.3145 8.81055V13C10.3145 13.2539 10.2266 13.4785 10.0508 13.6738C9.85547 13.8496 9.63086 13.9375 9.37695 13.9375C9.14258 13.9375 8.94727 13.8594 8.79102 13.7031L6.06641 11.5938C5.77344 11.3398 5.62695 11.0273 5.62695 10.6562V8.81055L0.734375 2.80469C0.558594 2.58984 0.470703 2.33594 0.470703 2.04297ZM2.08203 2.21875L6.88672 8.10742C6.98438 8.24414 7.0332 8.39062 7.0332 8.54688V10.5391L8.9082 12.0332V8.54688C8.9082 8.39062 8.95703 8.24414 9.05469 8.10742L13.8594 2.21875H2.08203Z'
            fill='#A7ACBD'
          />
        </svg>
      )
    }
    case 'infoCircle': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34314C4.84285 7.84343 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34314C16.1566 4.84285 14.1217 4 12 4ZM13 9L11 9L11 7L13 7L13 9ZM13 17L11 17L11 11L13 11L13 17Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    }
    case 'admin': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.1637 10.6023C16.1636 9.91806 15.9903 9.24483 15.6595 8.64458C15.3288 8.04433 14.8513 7.53633 14.271 7.16736C13.6908 6.79839 13.0263 6.58028 12.3389 6.53313C11.6515 6.48598 10.9632 6.6113 10.3374 6.89755C9.71154 7.18379 9.16826 7.62177 8.75755 8.17116C8.34685 8.72056 8.08191 9.36372 7.98713 10.0414C7.89236 10.7192 7.97078 11.4097 8.21519 12.0494C8.45961 12.6891 8.86215 13.2575 9.38577 13.7023C8.45609 14.1857 7.67747 14.9127 7.1344 15.8043C6.59133 16.696 6.30455 17.7184 6.30517 18.7604C6.3014 18.8699 6.31986 18.979 6.35945 19.0812C6.39903 19.1835 6.45893 19.2767 6.53559 19.3555C6.61224 19.4343 6.70407 19.4969 6.80561 19.5397C6.90715 19.5825 7.01633 19.6045 7.12663 19.6045C7.23693 19.6045 7.3461 19.5825 7.44765 19.5397C7.54919 19.4969 7.64102 19.4343 7.71767 19.3555C7.79432 19.2767 7.85423 19.1835 7.89381 19.0812C7.9334 18.979 7.95186 18.8699 7.94809 18.7604C7.94809 17.6786 8.38087 16.6411 9.15123 15.8761C9.92159 15.1111 10.9664 14.6814 12.0559 14.6814C13.1453 14.6814 14.1902 15.1111 14.9605 15.8761C15.7309 16.6411 16.1637 17.6786 16.1637 18.7604C16.1599 18.8699 16.1784 18.979 16.2179 19.0812C16.2575 19.1835 16.3174 19.2767 16.3941 19.3555C16.4707 19.4343 16.5626 19.4969 16.6641 19.5397C16.7656 19.5825 16.8748 19.6045 16.9851 19.6045C17.0954 19.6045 17.2046 19.5825 17.3061 19.5397C17.4077 19.4969 17.4995 19.4343 17.5762 19.3555C17.6528 19.2767 17.7127 19.1835 17.7523 19.0812C17.7919 18.979 17.8103 18.8699 17.8066 18.7604C17.8071 17.7184 17.5203 16.6961 16.9772 15.8044C16.4341 14.9128 15.6556 14.1858 14.726 13.7023C15.1774 13.3198 15.5397 12.8444 15.7879 12.3092C16.0361 11.7739 16.1643 11.1916 16.1637 10.6023ZM12.0597 13.0499C11.5722 13.0499 11.0957 12.9064 10.6903 12.6374C10.285 12.3685 9.96903 11.9862 9.78247 11.539C9.59591 11.0917 9.5471 10.5996 9.64221 10.1248C9.73732 9.64998 9.97207 9.21385 10.3168 8.87154C10.6615 8.52923 11.1007 8.29612 11.5788 8.20168C12.057 8.10723 12.5526 8.15571 13.003 8.34096C13.4534 8.52622 13.8383 8.83994 14.1092 9.24245C14.38 9.64496 14.5246 10.1182 14.5246 10.6023C14.5246 11.2514 14.2649 11.874 13.8026 12.333C13.3404 12.792 12.7134 13.0499 12.0597 13.0499Z'
            fill='#1D1D1F'
          />
          <path
            className='fill-none'
            d='M4.05299 5.2836C7.96129 4.99121 10.2382 3.7343 11.836 2C14.0439 4.0033 16.8942 5.16627 19.8827 5.2836C19.8827 7.34456 20.4582 11.7838 19.0599 15.4743C17.65 19.1934 14.2077 22.0029 12.02 22.0029C9.87936 22.0029 6.43528 19.517 4.81633 15.2237C3.69995 12.276 4.05299 7.70457 4.05299 5.2836Z'
            stroke='#1D1D1F'
            strokeWidth='2'
            strokeLinejoin='round'
          />
        </svg>
      )
    }
    case 'whatsapp': {
      return (
        <svg
          {...rest}
          className={className}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 500 500'
        >
          <g
            id='wab_white_copy'
            transform='matrix(0.691962, 0, 0, 0.691962, -94.016251, 7.477874)'
            style='transform-origin: 344.016px 242.522px;'
          >
            <path
              className='cls-1'
              d='M 664.348 240.158 C 664.348 416.748 521.348 559.888 344.928 559.888 C 291.514 559.971 238.941 546.588 192.068 520.978 C 191.762 520.814 191.406 520.767 191.068 520.848 L 25.458 564.568 C 24.409 564.846 23.452 563.884 23.735 562.836 C 23.736 562.834 23.737 562.831 23.738 562.828 L 68.088 400.588 C 68.187 400.227 68.137 399.841 67.948 399.518 C 40.046 351.049 25.405 296.084 25.498 240.158 C 25.498 63.578 168.498 -79.572 344.928 -79.572 C 371.024 -79.59 397.024 -76.413 422.348 -70.112 C 422.979 -69.952 423.419 -69.383 423.418 -68.732 L 423.418 -17.662 C 423.416 -16.721 422.51 -16.045 421.608 -16.312 C 396.727 -23.744 370.895 -27.507 344.928 -27.482 C 197.248 -27.482 77.538 92.348 77.538 240.158 C 77.448 293.725 93.499 346.077 123.598 390.388 C 123.826 390.725 123.899 391.144 123.798 391.538 L 107.418 453.968 L 98.208 489.098 C 97.936 490.14 98.886 491.089 99.928 490.818 L 135.368 481.458 L 198.628 464.778 C 199.01 464.676 199.417 464.741 199.748 464.958 C 242.971 492.996 293.407 507.879 344.928 507.798 C 492.598 507.798 612.308 387.968 612.308 240.148 C 612.327 215.68 608.999 191.324 602.418 167.758 C 602.167 166.862 602.837 165.973 603.768 165.968 L 654.578 165.968 C 655.237 165.969 655.809 166.425 655.958 167.068 C 661.551 191.028 664.367 215.553 664.348 240.158 Z'
              style='stroke-width: 1;'
            ></path>
            <path
              className='cls-1'
              d='M 654.698 8.308 L 654.698 57.828 C 654.703 58.614 654.064 59.253 653.278 59.248 L 581.148 59.248 C 580.366 59.253 579.733 59.886 579.728 60.668 L 579.728 135.598 C 579.733 136.384 579.094 137.023 578.308 137.018 L 528.778 137.018 C 527.993 137.018 527.358 136.382 527.358 135.598 L 527.358 60.668 C 527.358 59.884 526.722 59.248 525.938 59.248 L 453.808 59.248 C 453.023 59.248 452.388 58.612 452.388 57.828 L 452.388 8.308 C 452.393 7.526 453.026 6.893 453.808 6.888 L 525.938 6.888 C 526.724 6.893 527.363 6.254 527.358 5.468 L 527.358 -69.462 C 527.363 -70.244 527.996 -70.877 528.778 -70.882 L 578.308 -70.882 C 579.092 -70.882 579.728 -70.246 579.728 -69.462 L 579.728 5.458 C 579.728 6.242 580.363 6.878 581.148 6.878 L 653.278 6.878 C 654.066 6.878 654.703 7.52 654.698 8.308 Z'
              style='stroke-width: 1;'
            ></path>
            <path
              className='cls-1'
              d='M 239.378 92.988 C 235.878 92.988 232.378 92.988 228.878 92.988 C 227.965 92.948 227.051 93.046 226.168 93.278 C 220.168 95.278 214.738 98.088 210.398 102.848 C 204.098 109.738 198.098 116.848 193.488 125.008 C 190.067 131.113 187.496 137.657 185.848 144.458 C 184.475 150.286 183.605 156.221 183.248 162.198 C 182.496 174.841 184.09 187.514 187.948 199.578 C 190.306 206.92 193.246 214.062 196.738 220.938 C 201.816 230.958 207.688 240.555 214.298 249.638 C 220.038 257.698 225.828 265.718 231.928 273.528 C 238.228 281.598 244.858 289.378 251.748 296.948 C 259.198 305.128 267.038 312.948 275.168 320.458 C 281.028 325.888 287.088 331.078 293.278 336.098 C 304.588 345.152 316.57 353.335 329.118 360.578 C 333.048 362.878 337.028 365.168 341.118 367.088 C 348.258 370.418 355.508 373.518 362.818 376.458 C 369.218 379.018 375.748 381.248 382.238 383.558 C 386.538 385.088 390.948 386.348 395.238 387.968 C 401.401 390.42 407.877 391.998 414.478 392.658 C 426.258 393.658 438.168 394.248 449.958 391.398 C 454.702 390.237 459.337 388.665 463.808 386.698 C 471.342 383.352 478.422 379.065 484.878 373.938 C 492.368 368.088 498.878 361.578 501.798 352.078 C 504.718 342.578 506.938 332.838 506.858 322.738 C 507.015 318.707 504.736 314.977 501.078 313.278 C 492.888 309.068 484.578 305.088 476.398 300.848 C 470.398 297.758 464.178 295.218 458.148 292.228 C 450.468 288.428 442.758 284.718 434.778 281.578 C 428.068 278.938 423.158 280.328 418.778 286.128 C 416.778 288.848 414.778 291.618 412.638 294.308 C 406.358 302.388 399.638 310.068 392.898 317.788 C 389.058 322.208 384.158 322.308 379.388 320.848 C 373.852 319.04 368.469 316.796 363.288 314.138 C 355.088 310.138 346.898 306.058 339.288 301.008 C 331.998 296.198 324.658 291.418 318.028 285.728 C 297.092 268.258 279.468 247.166 265.998 223.458 C 263.858 219.678 262.998 215.458 265.728 211.378 C 266.718 209.941 267.808 208.574 268.988 207.288 C 275.988 199.208 283.578 191.558 288.458 181.818 C 290.838 177.068 292.138 172.558 289.608 167.378 C 286.708 161.428 283.998 155.378 281.658 149.178 C 278.468 140.778 274.778 132.598 271.478 124.258 C 268.758 117.378 266.118 110.458 263.058 103.738 C 260.328 97.738 256.058 92.438 247.658 93.008 C 244.888 93.138 242.128 92.988 239.378 92.988 Z'
              style='stroke-width: 1;'
            ></path>
          </g>
        </svg>
      )
    }

    case 'introduction': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M4.44033 10H19.5603L18.3603 4H5.64033L4.44033 10ZM13.0003 12V20H17.0003V22H7.00033V20H11.0003V12H2.99233C2.44433 12 2.08633 11.57 2.19533 11.023L3.80533 2.977C3.91333 2.437 4.44533 2 5.00033 2H18.9983C19.5513 2 20.0853 2.43 20.1943 2.977L21.8043 11.023C21.9123 11.563 21.5443 12 21.0073 12H13.0003Z' />
        </svg>
      )
    }
    case 'phone': {
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M7 4L7 20H17V4L7 4ZM6 2L18 2C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V21C19 21.2652 18.8946 21.5196 18.7071 21.7071C18.5196 21.8946 18.2652 22 18 22H6C5.73478 22 5.48043 21.8946 5.29289 21.7071C5.10536 21.5196 5 21.2652 5 21L5 3C5 2.73478 5.10536 2.48043 5.29289 2.29289C5.48043 2.10536 5.73478 2 6 2ZM12 17C12.2652 17 12.5196 17.1054 12.7071 17.2929C12.8946 17.4804 13 17.7348 13 18C13 18.2652 12.8946 18.5196 12.7071 18.7071C12.5196 18.8946 12.2652 19 12 19C11.7348 19 11.4804 18.8946 11.2929 18.7071C11.1054 18.5196 11 18.2652 11 18C11 17.7348 11.1054 17.4804 11.2929 17.2929C11.4804 17.1054 11.7348 17 12 17Z'
            fill='white'
          />
        </svg>
      )
    }
    case 'photo-id': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M18.4286 2C19.1518 2.02604 19.7545 2.27344 20.2366 2.74219C20.7188 3.21094 20.9732 3.79688 21 4.5V19.5C20.9732 20.2031 20.7188 20.7891 20.2366 21.2578C19.7545 21.7266 19.1518 21.974 18.4286 22H5.57143C4.84821 21.974 4.24554 21.7266 3.76339 21.2578C3.28125 20.7891 3.02679 20.2031 3 19.5V4.5C3.02679 3.79688 3.28125 3.21094 3.76339 2.74219C4.24554 2.27344 4.84821 2.02604 5.57143 2H18.4286ZM19.0714 19.5V4.5C19.0446 4.10938 18.8304 3.90104 18.4286 3.875H5.57143C5.16964 3.90104 4.95536 4.10938 4.92857 4.5V19.5C4.95536 19.8906 5.16964 20.099 5.57143 20.125H18.4286C18.8304 20.099 19.0446 19.8906 19.0714 19.5ZM16.5 17C16.9018 17.026 17.1161 17.2344 17.1429 17.625C17.1161 18.0156 16.9018 18.224 16.5 18.25H7.5C7.09821 18.224 6.88393 18.0156 6.85714 17.625C6.88393 17.2344 7.09821 17.026 7.5 17H16.5ZM12 14.8125C10.6339 14.7865 9.49554 14.3307 8.58482 13.4453C7.67411 12.5599 7.20536 11.4531 7.17857 10.125C7.20536 8.79688 7.67411 7.6901 8.58482 6.80469C9.49554 5.91927 10.6339 5.46354 12 5.4375C13.3661 5.46354 14.5045 5.91927 15.4152 6.80469C16.3259 7.6901 16.7946 8.79688 16.8214 10.125C16.7946 11.4531 16.3259 12.5599 15.4152 13.4453C14.5045 14.3307 13.3661 14.7865 12 14.8125ZM15.4554 9.5C15.2143 8.40625 14.5982 7.59896 13.6071 7.07812C13.8482 7.75521 14.0089 8.5625 14.0893 9.5H15.4554ZM14.0893 10.75C14.0089 11.6875 13.8482 12.4948 13.6071 13.1719C14.5982 12.651 15.2143 11.8438 15.4554 10.75H14.0893ZM12 6.76562C11.6518 7.10417 11.3839 8.01562 11.1964 9.5H12.8036C12.6161 8.01562 12.3482 7.10417 12 6.76562ZM12.8036 10.75H11.1964C11.3839 12.2344 11.6518 13.1458 12 13.4844C12.3482 13.1458 12.6161 12.2344 12.8036 10.75ZM10.433 7.07812C9.41518 7.59896 8.78571 8.40625 8.54464 9.5H9.91071C9.96429 8.5625 10.1384 7.75521 10.433 7.07812ZM9.91071 10.75H8.54464C8.78571 11.8438 9.41518 12.651 10.433 13.1719C10.1384 12.4948 9.96429 11.6875 9.91071 10.75Z' />
        </svg>
      )
    }
    case 'poa': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M7.91667 12C7.91667 11.6354 8.02604 11.3359 8.24479 11.1016C8.46354 10.8672 8.74306 10.75 9.08333 10.75H14.9167C15.2569 10.75 15.5365 10.8672 15.7552 11.1016C15.974 11.3359 16.0833 11.6354 16.0833 12V14.5C16.0833 14.8646 15.974 15.1641 15.7552 15.3984C15.5365 15.6328 15.2569 15.75 14.9167 15.75H9.08333C8.74306 15.75 8.46354 15.6328 8.24479 15.3984C8.02604 15.1641 7.91667 14.8646 7.91667 14.5V12ZM18.3073 5.63281C18.7691 6.1276 19 6.72656 19 7.42969V19.5C18.9757 20.2031 18.7448 20.7891 18.3073 21.2578C17.8698 21.7266 17.3229 21.974 16.6667 22H7.33333C6.67708 21.974 6.13021 21.7266 5.69271 21.2578C5.25521 20.7891 5.02431 20.2031 5 19.5V4.5C5.02431 3.79688 5.25521 3.21094 5.69271 2.74219C6.13021 2.27344 6.67708 2.02604 7.33333 2H13.9323C14.5885 2 15.1476 2.2474 15.6094 2.74219L18.3073 5.63281ZM17.25 19.5H17.2135V8.25H14.3333C13.9931 8.25 13.7135 8.13281 13.4948 7.89844C13.276 7.66406 13.1667 7.36458 13.1667 7V3.875H7.33333C6.96875 3.92708 6.77431 4.13542 6.75 4.5V19.5C6.77431 19.8906 6.96875 20.099 7.33333 20.125H16.6667C17.0312 20.099 17.2257 19.8906 17.25 19.5ZM8.5 7C8.13542 6.97396 7.94097 6.76562 7.91667 6.375C7.94097 5.98438 8.13542 5.77604 8.5 5.75H11.4167C11.7812 5.77604 11.9757 5.98438 12 6.375C11.9757 6.76562 11.7812 6.97396 11.4167 7H8.5ZM8.5 9.5C8.13542 9.47396 7.94097 9.26562 7.91667 8.875C7.94097 8.48438 8.13542 8.27604 8.5 8.25H11.4167C11.7812 8.27604 11.9757 8.48438 12 8.875C11.9757 9.26562 11.7812 9.47396 11.4167 9.5H8.5ZM15.5 17C15.8646 17.026 16.059 17.2344 16.0833 17.625C16.059 18.0156 15.8646 18.224 15.5 18.25H12.5833C12.2188 18.224 12.0243 18.0156 12 17.625C12.0243 17.2344 12.2188 17.026 12.5833 17H15.5Z' />
        </svg>
      )
    }
    case 'verify': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M17 15.244V22.116C17 22.2045 16.9766 22.2914 16.932 22.3678C16.8875 22.4442 16.8235 22.5075 16.7465 22.5511C16.6696 22.5947 16.5824 22.6171 16.4939 22.6161C16.4055 22.615 16.3189 22.5905 16.243 22.545L12 19.999L7.757 22.545C7.68104 22.5905 7.59436 22.615 7.50581 22.6161C7.41727 22.6171 7.33004 22.5946 7.25304 22.5509C7.17605 22.5071 7.11205 22.4437 7.06759 22.3671C7.02313 22.2906 6.9998 22.2035 7 22.115V15.245C5.70615 14.2091 4.76599 12.7969 4.30946 11.2035C3.85293 9.61019 3.90256 7.91439 4.45149 6.35047C5.00043 4.78655 6.02156 3.43175 7.37378 2.47328C8.726 1.51481 10.3425 1 12 1C13.6575 1 15.274 1.51481 16.6262 2.47328C17.9784 3.43175 18.9996 4.78655 19.5485 6.35047C20.0974 7.91439 20.1471 9.61019 19.6905 11.2035C19.234 12.7969 18.2939 14.2081 17 15.244ZM9 16.417V19.467L12 17.667L15 19.467V16.417C14.0468 16.8025 13.0282 17.0001 12 16.999C10.9718 17.0001 9.95316 16.8025 9 16.417ZM12 14.999C13.5913 14.999 15.1174 14.3669 16.2426 13.2416C17.3679 12.1164 18 10.5903 18 8.999C18 7.4077 17.3679 5.88158 16.2426 4.75636C15.1174 3.63114 13.5913 2.999 12 2.999C10.4087 2.999 8.88258 3.63114 7.75736 4.75636C6.63214 5.88158 6 7.4077 6 8.999C6 10.5903 6.63214 12.1164 7.75736 13.2416C8.88258 14.3669 10.4087 14.999 12 14.999Z'
            fill='#1D1D1F'
          />
          <path
            d='M15 6.171L16.414 7.585L11.464 12.535L7.928 8.999L9.344 7.585L11.465 9.707L15 6.171Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    }
    case 'add-card': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M19 3H3C1.89 3 1.01 3.89 1.01 5L1 17C1 18.11 1.89 19 3 19H13V17H3V11H21V5C21 3.89 20.11 3 19 3ZM19 7H3V5H19V7ZM23 16V18H20V21H18V18H15V16H18V13H20V16H23Z'
            fill='white'
          />
        </svg>
      )
    }
    case 'sendRequest': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385ZM12 10V7L16 11L12 15V12H8V10H12Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    }
    case 'team': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '25'}
            height={height || '24'}
            viewBox='0 0 25 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M2.16699 22C2.16699 19.8783 3.00985 17.8434 4.51014 16.3431C6.01043 14.8429 8.04526 14 10.167 14C12.2887 14 14.3236 14.8429 15.8238 16.3431C17.3241 17.8434 18.167 19.8783 18.167 22H16.167C16.167 20.4087 15.5349 18.8826 14.4096 17.7574C13.2844 16.6321 11.7583 16 10.167 16C8.57569 16 7.04957 16.6321 5.92435 17.7574C4.79913 18.8826 4.16699 20.4087 4.16699 22H2.16699ZM10.167 13C6.85199 13 4.16699 10.315 4.16699 7C4.16699 3.685 6.85199 1 10.167 1C13.482 1 16.167 3.685 16.167 7C16.167 10.315 13.482 13 10.167 13ZM10.167 11C12.377 11 14.167 9.21 14.167 7C14.167 4.79 12.377 3 10.167 3C7.95699 3 6.16699 4.79 6.16699 7C6.16699 9.21 7.95699 11 10.167 11ZM18.451 14.703C19.8563 15.3359 21.049 16.3612 21.8856 17.6557C22.7222 18.9502 23.1672 20.4587 23.167 22H21.167C21.1672 20.844 20.8335 19.7125 20.2061 18.7416C19.5786 17.7707 18.6841 17.0017 17.63 16.527L18.45 14.703H18.451ZM17.763 3.413C18.7705 3.8283 19.632 4.53354 20.238 5.43923C20.8441 6.34492 21.1674 7.41024 21.167 8.5C21.1674 9.87233 20.6547 11.1952 19.7295 12.2088C18.8044 13.2224 17.5337 13.8535 16.167 13.978V11.965C16.9079 11.8589 17.5953 11.518 18.1283 10.9925C18.6613 10.4669 19.0117 9.78432 19.1281 9.04493C19.2446 8.30555 19.121 7.5483 18.7754 6.88435C18.4298 6.22041 17.8804 5.68475 17.208 5.356L17.763 3.413Z' />
          </svg>
        </>
      )
    }
    case 'forward': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M13 14H11C9.3596 13.9994 7.75023 14.4471 6.34588 15.2949C4.94152 16.1427 3.7956 17.3582 3.032 18.81C3.01054 18.5405 2.99986 18.2703 3 18C3 12.477 7.477 8 13 8V2.5L23.5 11L13 19.5V14ZM11 12H15V15.308L20.321 11L15 6.692V10H13C11.8503 9.99871 10.7138 10.2458 9.66839 10.7244C8.62299 11.203 7.69332 11.9018 6.943 12.773C8.23432 12.2612 9.61096 11.9989 11 12Z'
            fill={fill || '#1D1D1F'}
          />
        </svg>
      )
    }
    case 'close': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || 24}
          height={height || 24}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Outlined/close'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M13.414 12L17.707 7.70701C18.098 7.31601 18.098 6.68401 17.707 6.29301C17.316 5.90201 16.684 5.90201 16.293 6.29301L12 10.586L7.70701 6.29301C7.31601 5.90201 6.68401 5.90201 6.29301 6.29301C5.90201 6.68401 5.90201 7.31601 6.29301 7.70701L10.586 12L6.29301 16.293C5.90201 16.684 5.90201 17.316 6.29301 17.707C6.48801 17.902 6.74401 18 7.00001 18C7.25601 18 7.51201 17.902 7.70701 17.707L12 13.414L16.293 17.707C16.488 17.902 16.744 18 17 18C17.256 18 17.512 17.902 17.707 17.707C18.098 17.316 18.098 16.684 17.707 16.293L13.414 12Z'
              fill='#172021'
            />
          </g>
        </svg>
      )
    }
    case 'settings': {
      return (
        <svg
          className={className}
          {...rest}
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10.417 4.5L16.417 9V10C17.117 10 17.787 10.1 18.417 10.29V8L10.417 2L2.41699 8V20H10.097C9.79699 19.38 9.59699 18.71 9.49699 18H4.41699V9L10.417 4.5Z'
            fill='#1D1D1F'
          />
          <path
            d='M20.6194 17.039C20.642 16.863 20.659 16.687 20.659 16.5C20.659 16.313 20.642 16.137 20.6194 15.961L21.8124 15.0535C21.9199 14.971 21.9481 14.8225 21.8803 14.7015L20.7494 12.7985C20.6985 12.7105 20.6024 12.661 20.5006 12.661C20.4667 12.661 20.4328 12.6665 20.4045 12.6775L18.9966 13.2275C18.7026 13.0075 18.3859 12.826 18.041 12.6885L17.8262 11.231C17.8092 11.099 17.6905 11 17.5491 11H15.2874C15.146 11 15.0273 11.099 15.0103 11.231L14.7955 12.6885C14.4505 12.826 14.1339 13.013 13.8399 13.2275L12.432 12.6775C12.398 12.6665 12.3641 12.661 12.3302 12.661C12.2341 12.661 12.1379 12.7105 12.0871 12.7985L10.9562 14.7015C10.8827 14.8225 10.9166 14.971 11.024 15.0535L12.2171 15.961C12.1945 16.137 12.1775 16.3185 12.1775 16.5C12.1775 16.6815 12.1945 16.863 12.2171 17.039L11.024 17.9465C10.9166 18.029 10.8883 18.1775 10.9562 18.2985L12.0871 20.2015C12.1379 20.2895 12.2341 20.339 12.3358 20.339C12.3698 20.339 12.4037 20.3335 12.432 20.3225L13.8399 19.7725C14.1339 19.9925 14.4505 20.174 14.7955 20.3115L15.0103 21.769C15.0273 21.901 15.146 22 15.2874 22H17.5491C17.6905 22 17.8092 21.901 17.8262 21.769L18.041 20.3115C18.3859 20.174 18.7026 19.987 18.9966 19.7725L20.4045 20.3225C20.4384 20.3335 20.4724 20.339 20.5063 20.339C20.6024 20.339 20.6985 20.2895 20.7494 20.2015L21.8803 18.2985C21.9481 18.1775 21.9199 18.029 21.8124 17.9465L20.6194 17.039ZM19.4998 16.0985C19.5224 16.269 19.5281 16.3845 19.5281 16.5C19.5281 16.6155 19.5168 16.7365 19.4998 16.9015L19.4207 17.523L19.9239 17.908L20.5346 18.37L20.1388 19.0355L19.4207 18.755L18.8326 18.524L18.3237 18.898C18.0806 19.074 17.8488 19.206 17.617 19.2995L17.0176 19.536L16.9271 20.1575L16.814 20.9H16.0224L15.8245 19.536L15.2252 19.2995C14.9821 19.2005 14.7559 19.074 14.5297 18.909L14.0152 18.524L13.4158 18.7605L12.6977 19.041L12.3019 18.3755L12.9126 17.9135L13.4158 17.5285L13.3367 16.907C13.3197 16.7365 13.3084 16.61 13.3084 16.5C13.3084 16.39 13.3197 16.2635 13.3367 16.0985L13.4158 15.477L12.9126 15.092L12.3019 14.63L12.6977 13.9645L13.4158 14.245L14.0039 14.476L14.5127 14.102C14.7559 13.926 14.9877 13.794 15.2195 13.7005L15.8189 13.464L15.9094 12.8425L16.0224 12.1H16.8084L17.0063 13.464L17.6056 13.7005C17.8488 13.7995 18.0749 13.926 18.3011 14.091L18.8157 14.476L19.415 14.2395L20.1331 13.959L20.5289 14.6245L19.9239 15.092L19.4207 15.477L19.4998 16.0985ZM16.4182 14.3C15.1686 14.3 14.1565 15.2845 14.1565 16.5C14.1565 17.7155 15.1686 18.7 16.4182 18.7C17.6678 18.7 18.68 17.7155 18.68 16.5C18.68 15.2845 17.6678 14.3 16.4182 14.3ZM16.4182 17.6C15.7963 17.6 15.2874 17.105 15.2874 16.5C15.2874 15.895 15.7963 15.4 16.4182 15.4C17.0402 15.4 17.5491 15.895 17.5491 16.5C17.5491 17.105 17.0402 17.6 16.4182 17.6Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    }
    case 'mailDefault': {
      return (
        <svg
          className={className}
          {...rest}
          width='25'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3ZM20 7.238L12.072 14.338L4 7.216V19H20V7.238ZM4.511 5L12.061 11.662L19.502 5H4.511Z' />
        </svg>
      )
    }
    case 'info': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '18'}
            height={height || '18'}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M12.167 22C6.64399 22 2.16699 17.523 2.16699 12C2.16699 6.477 6.64399 2 12.167 2C17.69 2 22.167 6.477 22.167 12C22.167 17.523 17.69 22 12.167 22ZM12.167 20C14.2887 20 16.3236 19.1571 17.8238 17.6569C19.3241 16.1566 20.167 14.1217 20.167 12C20.167 9.87827 19.3241 7.84344 17.8238 6.34315C16.3236 4.84285 14.2887 4 12.167 4C10.0453 4 8.01043 4.84285 6.51014 6.34315C5.00985 7.84344 4.16699 9.87827 4.16699 12C4.16699 14.1217 5.00985 16.1566 6.51014 17.6569C8.01043 19.1571 10.0453 20 12.167 20ZM11.167 15H13.167V17H11.167V15ZM13.167 13.355V14H11.167V12.5C11.167 12.2348 11.2723 11.9804 11.4599 11.7929C11.6474 11.6054 11.9018 11.5 12.167 11.5C12.4511 11.5 12.7293 11.4193 12.9693 11.2673C13.2093 11.1154 13.4013 10.8984 13.5228 10.6416C13.6443 10.3848 13.6904 10.0988 13.6557 9.81684C13.621 9.53489 13.5069 9.26858 13.3268 9.04891C13.1467 8.82924 12.9079 8.66523 12.6382 8.57597C12.3685 8.48671 12.079 8.47587 11.8034 8.54471C11.5278 8.61354 11.2774 8.75923 11.0814 8.96482C10.8853 9.1704 10.7517 9.42743 10.696 9.706L8.73399 9.313C8.85562 8.70508 9.1365 8.14037 9.54791 7.67659C9.95932 7.2128 10.4865 6.86658 11.0756 6.67332C11.6647 6.48006 12.2945 6.44669 12.9007 6.57661C13.5069 6.70654 14.0677 6.99511 14.5258 7.41282C14.9839 7.83054 15.3229 8.36241 15.5081 8.95406C15.6933 9.54572 15.7181 10.1759 15.5799 10.7803C15.4417 11.3847 15.1454 11.9415 14.7215 12.3939C14.2976 12.8462 13.7611 13.1779 13.167 13.355Z'
              fill='#1D1D1F'
            />
          </svg>
        </>
      )
    }
    case 'add-user': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '24'}
            height={height || '24'}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M12.5 14.752V16.842C11.5949 16.522 10.6263 16.4239 9.6754 16.5558C8.72453 16.6877 7.8192 17.0459 7.03543 17.6002C6.25166 18.1545 5.61234 18.8888 5.17116 19.7414C4.72998 20.594 4.49982 21.54 4.5 22.5L2.5 22.499C2.49969 21.2779 2.77892 20.0729 3.3163 18.9764C3.85368 17.8799 4.63494 16.9209 5.60022 16.173C6.5655 15.4251 7.68918 14.9081 8.88515 14.6616C10.0811 14.4152 11.3177 14.4457 12.5 14.751V14.752ZM10.5 13.5C7.185 13.5 4.5 10.815 4.5 7.5C4.5 4.185 7.185 1.5 10.5 1.5C13.815 1.5 16.5 4.185 16.5 7.5C16.5 10.815 13.815 13.5 10.5 13.5ZM10.5 11.5C12.71 11.5 14.5 9.71 14.5 7.5C14.5 5.29 12.71 3.5 10.5 3.5C8.29 3.5 6.5 5.29 6.5 7.5C6.5 9.71 8.29 11.5 10.5 11.5ZM16.5 17.5V14.5H18.5V17.5H21.5V19.5H18.5V22.5H16.5V19.5H13.5V17.5H16.5Z' />
          </svg>
        </>
      )
    }
    case 'delete': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '24'}
            height={height || '24'}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M4 8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z'
              fill='#1D1D1F'
            />
          </svg>
        </>
      )
    }
    case 'hamburger-menu': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '24'}
            height={height || '24'}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <defs></defs>
            <path
              d='M 3 20 L 21 20 L 21 18 L 3 18 L 3 20 Z M 9 13 L 21 13 L 21 11 L 9 11 L 9 13 Z M 3 6 L 21 6 L 21 4 L 3 4 L 3 6 Z'
              fill='#1D1D1F'
              style='transform-box: fill-box; transform-origin: 50% 50%;'
              transform='matrix(-1, 0, 0, -1, 0.000001, 0.000001)'
            ></path>
          </svg>
        </>
      )
    }
    case 'calendar': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            xmlns='http://www.w3.org/2000/svg'
            width={width || '20'}
            height={height || '20'}
            fill='none'
            viewBox='0 0 20 20'
          >
            <path
              id='Vector'
              fill='#6E6E73'
              d='M15 2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4V0h2v2h6V0h2zm3 8H2v8h16zm-5-6H7v2H5V4H2v4h16V4h-3v2h-2zm-9 8h2v2H4zm5 0h2v2H9zm5 0h2v2h-2z'
            ></path>
          </svg>
        </>
      )
    }
    case 'code': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '25'}
            height={height || '24'}
            viewBox='0 0 25 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M24.167 12L18.51 17.657L17.096 16.243L21.339 12L17.096 7.757L18.51 6.343L24.167 12ZM2.99499 12L7.23799 16.243L5.82399 17.657L0.166992 12L5.82399 6.343L7.23699 7.757L2.99499 12ZM9.95499 21H7.82699L14.379 3H16.507L9.95499 21Z' />
          </svg>
        </>
      )
    }
    case 'error': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z' />
          </svg>
        </>
      )
    }
    case 'download': {
      return (
        <svg
          {...rest}
          className={className}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12H16L12 16L8 12H11V8H13V12Z' />
        </svg>
      )
    }
    case 'mail': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '25'}
            height={width || '24'}
            viewBox='0 0 25 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M22.167 9.98V19C22.167 20.1 21.267 21 20.167 21H4.16699C3.06699 21 2.16699 20.1 2.16699 19L2.17699 7C2.17699 5.9 3.06699 5 4.16699 5H14.267C14.207 5.32 14.167 5.66 14.167 6C14.167 6.34 14.207 6.68 14.267 7H4.16699L12.167 12L15.837 9.71C16.307 10.14 16.857 10.47 17.467 10.69L12.167 14L4.16699 9V19H20.167V10.9C20.907 10.75 21.587 10.42 22.167 9.98ZM16.167 6C16.167 7.66 17.507 9 19.167 9C20.827 9 22.167 7.66 22.167 6C22.167 4.34 20.827 3 19.167 3C17.507 3 16.167 4.34 16.167 6Z' />
          </svg>
        </>
      )
    }
    case 'warning': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '24'}
            height={height || '24'}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M12.8661 2.99999L22.3921 19.5C22.4799 19.652 22.5261 19.8244 22.5261 20C22.5261 20.1755 22.4799 20.348 22.3921 20.5C22.3043 20.652 22.1781 20.7782 22.0261 20.866C21.8741 20.9538 21.7016 21 21.5261 21H2.4741C2.29856 21 2.12612 20.9538 1.9741 20.866C1.82209 20.7782 1.69585 20.652 1.60809 20.5C1.52032 20.348 1.47412 20.1755 1.47412 20C1.47412 19.8244 1.52033 19.652 1.6081 19.5L11.1341 2.99999C11.2219 2.84798 11.3481 2.72175 11.5001 2.63399C11.6521 2.54623 11.8246 2.50003 12.0001 2.50003C12.1756 2.50003 12.3481 2.54623 12.5001 2.63399C12.6521 2.72175 12.7783 2.84798 12.8661 2.99999ZM4.2061 19H19.7941L12.0001 5.49999L4.2061 19ZM11.0001 16H13.0001V18H11.0001V16ZM11.0001 8.99999H13.0001V14H11.0001V8.99999Z' />
          </svg>
        </>
      )
    }
    case 'logout': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '25'}
          height={height || '24'}
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M17.167 8L15.757 9.41L17.337 11H9.16699V13H17.337L15.757 14.58L17.167 16L21.167 12L17.167 8ZM5.16699 5H12.167V3H5.16699C4.06699 3 3.16699 3.9 3.16699 5V19C3.16699 20.1 4.06699 21 5.16699 21H12.167V19H5.16699V5Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    }
    case 'business-settings': {
      return (
        <svg
          {...rest}
          className={className}
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
        >
          <path d='M10.5 4.5L16.5 9V10C17.2 10 17.87 10.1 18.5 10.29V8L10.5 2L2.5 8V20H10.18C9.88 19.38 9.68 18.71 9.58 18H4.5V9L10.5 4.5Z' />
          <path d='M20.7024 17.039C20.725 16.863 20.742 16.687 20.742 16.5C20.742 16.313 20.725 16.137 20.7024 15.961L21.8954 15.0535C22.0029 14.971 22.0311 14.8225 21.9633 14.7015L20.8324 12.7985C20.7815 12.7105 20.6854 12.661 20.5836 12.661C20.5497 12.661 20.5158 12.6665 20.4875 12.6775L19.0796 13.2275C18.7856 13.0075 18.4689 12.826 18.124 12.6885L17.9092 11.231C17.8922 11.099 17.7735 11 17.6321 11H15.3704C15.229 11 15.1103 11.099 15.0933 11.231L14.8785 12.6885C14.5336 12.826 14.2169 13.013 13.9229 13.2275L12.515 12.6775C12.481 12.6665 12.4471 12.661 12.4132 12.661C12.3171 12.661 12.2209 12.7105 12.1701 12.7985L11.0392 14.7015C10.9657 14.8225 10.9996 14.971 11.1071 15.0535L12.3001 15.961C12.2775 16.137 12.2605 16.3185 12.2605 16.5C12.2605 16.6815 12.2775 16.863 12.3001 17.039L11.1071 17.9465C10.9996 18.029 10.9714 18.1775 11.0392 18.2985L12.1701 20.2015C12.2209 20.2895 12.3171 20.339 12.4188 20.339C12.4528 20.339 12.4867 20.3335 12.515 20.3225L13.9229 19.7725C14.2169 19.9925 14.5336 20.174 14.8785 20.3115L15.0933 21.769C15.1103 21.901 15.229 22 15.3704 22H17.6321C17.7735 22 17.8922 21.901 17.9092 21.769L18.124 20.3115C18.4689 20.174 18.7856 19.987 19.0796 19.7725L20.4875 20.3225C20.5215 20.3335 20.5554 20.339 20.5893 20.339C20.6854 20.339 20.7815 20.2895 20.8324 20.2015L21.9633 18.2985C22.0311 18.1775 22.0029 18.029 21.8954 17.9465L20.7024 17.039ZM19.5828 16.0985C19.6055 16.269 19.6111 16.3845 19.6111 16.5C19.6111 16.6155 19.5998 16.7365 19.5828 16.9015L19.5037 17.523L20.0069 17.908L20.6176 18.37L20.2218 19.0355L19.5037 18.755L18.9156 18.524L18.4067 18.898C18.1636 19.074 17.9318 19.206 17.7 19.2995L17.1006 19.536L17.0101 20.1575L16.897 20.9H16.1054L15.9075 19.536L15.3082 19.2995C15.0651 19.2005 14.8389 19.074 14.6127 18.909L14.0982 18.524L13.4988 18.7605L12.7807 19.041L12.3849 18.3755L12.9956 17.9135L13.4988 17.5285L13.4197 16.907C13.4027 16.7365 13.3914 16.61 13.3914 16.5C13.3914 16.39 13.4027 16.2635 13.4197 16.0985L13.4988 15.477L12.9956 15.092L12.3849 14.63L12.7807 13.9645L13.4988 14.245L14.0869 14.476L14.5958 14.102C14.8389 13.926 15.0707 13.794 15.3025 13.7005L15.9019 13.464L15.9924 12.8425L16.1054 12.1H16.8914L17.0893 13.464L17.6887 13.7005C17.9318 13.7995 18.158 13.926 18.3841 14.091L18.8987 14.476L19.498 14.2395L20.2161 13.959L20.6119 14.6245L20.0069 15.092L19.5037 15.477L19.5828 16.0985ZM16.5012 14.3C15.2517 14.3 14.2395 15.2845 14.2395 16.5C14.2395 17.7155 15.2517 18.7 16.5012 18.7C17.7508 18.7 18.763 17.7155 18.763 16.5C18.763 15.2845 17.7508 14.3 16.5012 14.3ZM16.5012 17.6C15.8793 17.6 15.3704 17.105 15.3704 16.5C15.3704 15.895 15.8793 15.4 16.5012 15.4C17.1232 15.4 17.6321 15.895 17.6321 16.5C17.6321 17.105 17.1232 17.6 16.5012 17.6Z' />
        </svg>
      )
    }
    case 'invoices': {
      return (
        <svg
          {...rest}
          className={className}
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
        >
          <path
            d='M20.167 18H4.16699V6H12.167V4H4.16699C3.05699 4 2.16699 4.89 2.16699 6V18C2.16699 19.1 3.05699 20 4.16699 20H8.16699V22H16.167V20H20.167C21.267 20 22.167 19.1 22.167 18V15H20.167V18Z'
            fill='#1D1D1F'
          />
          <path
            d='M18.157 8.1C16.377 7.51 15.517 7.14 15.517 6.2C15.517 5.18 16.627 4.81 17.327 4.81C18.637 4.81 19.117 5.8 19.227 6.15L20.807 5.48C20.657 5.03 19.987 3.56 18.267 3.24V2H16.267V3.26C13.787 3.82 13.777 6.12 13.777 6.22C13.777 8.49 16.027 9.13 17.127 9.53C18.707 10.09 19.407 10.6 19.407 11.56C19.407 12.69 18.357 13.17 17.427 13.17C15.607 13.17 15.087 11.3 15.027 11.08L13.367 11.75C13.997 13.94 15.647 14.53 16.267 14.71V16H18.267V14.76C18.667 14.67 21.167 14.17 21.167 11.54C21.167 10.15 20.557 8.93 18.157 8.1Z'
            fill='#1D1D1F'
          />
          <path
            d='M6.16699 14H10.167V16H6.16699V14ZM6.16699 11H12.167V13H6.16699V11ZM6.16699 8H12.167V10H6.16699V8Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    }
    case 'dashboard': {
      return (
        <svg
          className={className}
          {...rest}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='6.35865' cy='6.35889' r='3.52564' fill='#1D1D1F' />
          <circle
            cx='6.35865'
            cy='17.6411'
            r='2.82564'
            className='stroke'
            stroke='#1D1D1F'
            strokeWidth='1.4'
          />
          <circle
            cx='17.6409'
            cy='6.35889'
            r='2.82564'
            className='stroke'
            stroke='#1D1D1F'
            strokeWidth='1.4'
          />
          <path
            d='M17.5 14.5002V21.0002'
            stroke='#1D1D1F'
            className='stroke'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M20.75 17.7502L14.25 17.7502'
            stroke='#1D1D1F'
            className='stroke'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )
    }
    case 'market': {
      return (
        <svg
          {...rest}
          className={className}
          width={width || '25'}
          height={height || '24'}
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M22.065 8.89L21.015 4.52C20.795 3.62 20.015 3 19.105 3H5.21505C4.31505 3 3.52505 3.63 3.31505 4.52L2.26505 8.89C2.02505 9.91 2.24505 10.95 2.88505 11.77C2.96505 11.88 3.07505 11.96 3.16505 12.06V19C3.16505 20.1 4.06505 21 5.16505 21H19.165C20.265 21 21.165 20.1 21.165 19V12.06C21.255 11.97 21.365 11.88 21.445 11.78C22.085 10.96 22.315 9.91 22.065 8.89ZM19.075 4.99L20.125 9.36C20.225 9.78 20.135 10.2 19.875 10.53C19.735 10.71 19.435 11 18.935 11C18.325 11 17.795 10.51 17.725 9.86L17.145 5L19.075 4.99ZM13.165 5H15.125L15.665 9.52C15.715 9.91 15.595 10.3 15.335 10.59C15.115 10.85 14.795 11 14.385 11C13.715 11 13.165 10.41 13.165 9.69V5ZM8.65505 9.52L9.20505 5H11.165V9.69C11.165 10.41 10.615 11 9.87505 11C9.53505 11 9.22505 10.85 8.98505 10.59C8.73505 10.3 8.61505 9.91 8.65505 9.52ZM4.20505 9.36L5.21505 5H7.18505L6.60505 9.86C6.52505 10.51 6.00505 11 5.39505 11C4.90505 11 4.59505 10.71 4.46505 10.53C4.19505 10.21 4.10505 9.78 4.20505 9.36ZM5.16505 19V12.97C5.24505 12.98 5.31505 13 5.39505 13C6.26505 13 7.05505 12.64 7.63505 12.05C8.23505 12.65 9.03505 13 9.94505 13C10.815 13 11.595 12.64 12.175 12.07C12.765 12.64 13.565 13 14.465 13C15.305 13 16.105 12.65 16.705 12.05C17.285 12.64 18.075 13 18.945 13C19.025 13 19.095 12.98 19.175 12.97V19H5.16505Z' />
        </svg>
      )
    }
    case 'edit': {
      return (
        <>
          <svg
            className={className}
            {...rest}
            width={width || '24'}
            height={height || '24'}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M14.0585 9.02L14.9785 9.94L5.91854 19H4.99854V18.08L14.0585 9.02ZM17.6585 3C17.4085 3 17.1485 3.1 16.9585 3.29L15.1285 5.12L18.8785 8.87L20.7085 7.04C21.0985 6.65 21.0985 6.02 20.7085 5.63L18.3685 3.29C18.1685 3.09 17.9185 3 17.6585 3ZM14.0585 6.19L2.99854 17.25V21H6.74854L17.8085 9.94L14.0585 6.19Z' />
          </svg>
        </>
      )
    }
    case 'account':
      return (
        <>
          <svg
            className={className}
            {...rest}
            xmlns='http://www.w3.org/2000/svg'
            width={24}
            height={24}
            fill='none'
          >
            <path d='M20 17H4V5h8V3H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h4v2h8v-2h4c1.1 0 2-.9 2-2v-3h-2v3Z' />
            <path d='M17.99 7.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.45-.82-1.92-2.54-2.24V1h-2v1.26c-2.48.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 2.9 2.96V15h2v-1.24c.4-.09 2.9-.59 2.9-3.22 0-1.39-.61-2.61-3.01-3.44ZM6 13h4v2H6v-2Zm0-3h6v2H6v-2Zm0-3h6v2H6V7Z' />
          </svg>
        </>
      )
    case 'check-circle':
      return (
        <svg
          {...rest}
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle className={className} cx='12' cy='12' r='11' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.6241 16.1252C10.8954 16.1256 11.164 16.072 11.4142 15.9674C11.6645 15.8628 11.8914 15.7094 12.0816 15.5161L17.0976 10.2457C17.3553 9.98387 17.4997 9.63127 17.4997 9.26395C17.4997 8.89663 17.3553 8.54402 17.0976 8.2822C16.9707 8.15324 16.8194 8.05082 16.6525 7.98091C16.4856 7.911 16.3065 7.875 16.1255 7.875C15.9446 7.875 15.7654 7.911 15.5985 7.98091C15.4316 8.05082 15.2803 8.15324 15.1534 8.2822L10.6241 13.0617L8.84627 11.0377C8.71934 10.9087 8.56802 10.8063 8.40113 10.7364C8.23423 10.6665 8.05509 10.6305 7.87414 10.6305C7.6932 10.6305 7.51406 10.6665 7.34716 10.7364C7.18027 10.8063 7.02895 10.9087 6.90202 11.0377C6.64439 11.2995 6.5 11.6521 6.5 12.0194C6.5 12.3868 6.64439 12.7394 6.90202 13.0012L9.16527 15.5216C9.35606 15.7142 9.58337 15.8668 9.83387 15.9704C10.0844 16.0741 10.353 16.1267 10.6241 16.1252Z'
            fill='white'
          />
        </svg>
      )
    case 'check-outline':
      return (
        <svg
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          className={className}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11.003 16L6.76 11.757L8.174 10.343L11.003 13.172L16.659 7.515L18.074 8.929L11.003 16Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    case 'copy':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '15'}
          height={height || '18'}
          viewBox='0 0 15 18'
          fill='none'
          {...rest}
        >
          <g clipPath='url(#clip0_735_10181)'>
            <path
              d='M12.1386 11.8125H6.0693C5.79113 11.8125 5.56353 11.5594 5.56353 11.25V2.25C5.56353 1.94062 5.79113 1.6875 6.0693 1.6875H10.498L12.6444 4.07461V11.25C12.6444 11.5594 12.4168 11.8125 12.1386 11.8125ZM6.0693 13.5H12.1386C13.2545 13.5 14.1617 12.491 14.1617 11.25V4.07461C14.1617 3.62812 14.0005 3.19922 13.716 2.88281L11.5728 0.495703C11.2883 0.179297 10.9026 0 10.5012 0H6.0693C4.95344 0 4.0462 1.00898 4.0462 2.25V11.25C4.0462 12.491 4.95344 13.5 6.0693 13.5ZM2.0231 4.5C0.907235 4.5 0 5.50898 0 6.75V15.75C0 16.991 0.907235 18 2.0231 18H8.09241C9.20827 18 10.1155 16.991 10.1155 15.75V14.625H8.59818V15.75C8.59818 16.0594 8.37058 16.3125 8.09241 16.3125H2.0231C1.74493 16.3125 1.51733 16.0594 1.51733 15.75V6.75C1.51733 6.44063 1.74493 6.1875 2.0231 6.1875H3.03465V4.5H2.0231Z'
              fill='#6E6E73'
            />
          </g>
          <defs>
            <clipPath id='clip0_735_10181'>
              <rect width='14.1617' height='18' fill='white' />
            </clipPath>
          </defs>
        </svg>
      )
    case 'download-outline':
      return (
        <svg
          className={className}
          {...rest}
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
        >
          <path
            d='M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12H16L12 16L8 12H11V8H13V12Z'
            fill={'white'}
          />
        </svg>
      )
    case 'scan':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '18'}
          height={height || '15'}
          viewBox='0 0 18 15'
          fill='none'
          {...rest}
        >
          <path
            d='M1 8H17C17.2652 8 17.5196 8.10536 17.7071 8.29289C17.8946 8.48043 18 8.73478 18 9V14C18 14.2652 17.8946 14.5196 17.7071 14.7071C17.5196 14.8946 17.2652 15 17 15H1C0.734784 15 0.48043 14.8946 0.292893 14.7071C0.105357 14.5196 0 14.2652 0 14V9C0 8.73478 0.105357 8.48043 0.292893 8.29289C0.48043 8.10536 0.734784 8 1 8ZM2 10V13H16V10H2Z'
            fill='white'
          />
          <path
            d='M4.5241 0.148342C4.05374 -0.141109 3.43779 0.00554466 3.14834 0.475903C2.85889 0.94626 3.00554 1.56221 3.4759 1.85166L4.5241 0.148342ZM3.4759 1.85166L16.4759 9.85166L17.5241 8.14834L4.5241 0.148342L3.4759 1.85166Z'
            fill='white'
          />
        </svg>
      )
    case 'circle':
      return (
        <svg
          className={className}
          {...rest}
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
        >
          <path
            d='M12.5 22C6.977 22 2.5 17.523 2.5 12C2.5 6.477 6.977 2 12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22ZM12.5 20C14.6217 20 16.6566 19.1571 18.1569 17.6569C19.6571 16.1566 20.5 14.1217 20.5 12C20.5 9.87827 19.6571 7.84344 18.1569 6.34315C16.6566 4.84285 14.6217 4 12.5 4C10.3783 4 8.34344 4.84285 6.84315 6.34315C5.34285 7.84344 4.5 9.87827 4.5 12C4.5 14.1217 5.34285 16.1566 6.84315 17.6569C8.34344 19.1571 10.3783 20 12.5 20Z'
            fill={'#6E6E73'}
          />
        </svg>
      )
    case 'user-settings':
      return (
        <svg
          className={className}
          {...rest}
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
        >
          <path
            d='M12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM14.595 18.812C14.4682 18.2784 14.4682 17.7226 14.595 17.189L13.603 16.616L14.603 14.884L15.595 15.457C15.9932 15.0799 16.4745 14.8017 17 14.645V13.5H19V14.645C19.532 14.803 20.012 15.085 20.405 15.457L21.397 14.884L22.397 16.616L21.405 17.189C21.5316 17.7222 21.5316 18.2778 21.405 18.811L22.397 19.384L21.397 21.116L20.405 20.543C20.0068 20.9201 19.5255 21.1983 19 21.355V22.5H17V21.355C16.4745 21.1983 15.9932 20.9201 15.595 20.543L14.603 21.116L13.603 19.384L14.595 18.812ZM18 19.5C18.3978 19.5 18.7794 19.342 19.0607 19.0607C19.342 18.7794 19.5 18.3978 19.5 18C19.5 17.6022 19.342 17.2206 19.0607 16.9393C18.7794 16.658 18.3978 16.5 18 16.5C17.6022 16.5 17.2206 16.658 16.9393 16.9393C16.658 17.2206 16.5 17.6022 16.5 18C16.5 18.3978 16.658 18.7794 16.9393 19.0607C17.2206 19.342 17.6022 19.5 18 19.5Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    case 'trash':
      return (
        <svg
          className={className}
          {...rest}
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
        >
          <path
            d='M4 8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z'
            fill='#1D1D1F'
          />
        </svg>
      )
    case 'user':
      return (
        <svg
          className={className}
          {...rest}
          xmlns='http://www.w3.org/2000/svg'
          width={width || '16'}
          height={height || '21'}
          viewBox='0 0 16 21'
        >
          <path d='M0 21C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13C10.1217 13 12.1566 13.8429 13.6569 15.3431C15.1571 16.8434 16 18.8783 16 21H14C14 19.4087 13.3679 17.8826 12.2426 16.7574C11.1174 15.6321 9.5913 15 8 15C6.4087 15 4.88258 15.6321 3.75736 16.7574C2.63214 17.8826 2 19.4087 2 21H0ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10Z' />
        </svg>
      )
    case 'chevron-right':
      return (
        <svg
          className={className}
          {...rest}
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 16 16'
        >
          <path
            fillRule='evenodd'
            d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'
          />
        </svg>
      )
    case 'chevron-left':
      return (
        <svg
          className={className}
          {...rest}
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 16 16'
        >
          <path
            fillRule='evenodd'
            d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'
          />
        </svg>
      )
    case 'storage':
      return (
        <svg
          className={className}
          {...rest}
          xmlns='http://www.w3.org/2000/svg'
          width={width || '21'}
          height={height || '24'}
          fill='none'
          viewBox='0 0 21 24'
        >
          <path
            fill='#000'
            d='M18 0q1.266.047 2.11.89.843.844.89 2.11v18q-.047 1.266-.89 2.11-.844.843-2.11.89H3q-1.266-.047-2.11-.89Q.048 22.265 0 21V3Q.047 1.734.89.89 1.735.048 3 0zm0 21.75q.704-.046.75-.75v-7.875H2.25V21q.046.704.75.75zm.75-10.875V3q-.046-.703-.75-.75H3q-.703.046-.75.75v7.875zM6 7.875q-.703-.046-.75-.75V6q0-.656.422-1.078Q6.093 4.5 6.75 4.5h7.5q.657 0 1.078.422.422.421.422 1.078v1.125q-.047.704-.75.75h-.75q-.703-.046-.75-.75V6.75h-6v.375q-.046.704-.75.75zm0 11.25q-.703-.046-.75-.75V17.25q0-.656.422-1.078.421-.422 1.078-.422h7.5q.657 0 1.078.422.422.421.422 1.078v1.125q-.047.704-.75.75h-.75q-.703-.046-.75-.75V18h-6v.375q-.046.704-.75.75z'
          ></path>
        </svg>
      )
    case 'user-circle-filled':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '34'}
          height={height || '34'}
          fill='none'
          viewBox='0 0 34 34'
          {...rest}
        >
          <circle cx='17' cy='17' r='17' fill='#1D1D1F'></circle>
          <path
            fill='#fff'
            d='M10.906 25a6.095 6.095 0 0 1 12.19 0h-1.523a4.571 4.571 0 1 0-9.143 0zm6.095-6.857a4.57 4.57 0 0 1-4.57-4.572A4.57 4.57 0 0 1 17 9a4.57 4.57 0 0 1 4.572 4.571 4.57 4.57 0 0 1-4.571 4.572m0-1.524a3.047 3.047 0 1 0 0-6.095 3.047 3.047 0 1 0 0 6.095'
          ></path>
        </svg>
      )
    case 'hamburger-straight':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '14'}
          height={height || '10'}
          fill='none'
          viewBox='0 0 14 10'
          {...rest}
        >
          <path
            fill='#1D1D1F'
            d='M0 1a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1M0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1M0 9a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1'
          ></path>
        </svg>
      )
    case 'circle-help':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || '24'}
          fill='none'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          viewBox='0 0 24 24'
        >
          <circle cx='12' cy='12' r='10'></circle>
          <path d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01'></path>
        </svg>
      )
    default:
      return null
  }
}

export default Icon
